import React from 'react'
import { ToastContainer } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import NumberInput from '../../Component/PhoneInput/phoneInput';
import UseEditProvider from './Hooks/useEditProvider';

const EditServiceProvider = () => {
  const {
    spinner,
    editServiceProvider
  } = UseEditProvider()

  return (
    <>
      <ToastContainer />
      <section>
        <div className="cus-padd cusheight">
          {spinner ? <Spinner /> : null}
          <header>
            <h2 className='page-tittle'>
              Edit Provider
            </h2>
            <hr />
          </header>
          <form className="row g-3 mt-4" onSubmit={editServiceProvider.handleSubmit}>
            <h5>Basic Details</h5>
            <div className="col-md-6">
              <label htmlFor="recipient-name" className="col-form-label">Name*</label>
              <input type="text" className="form-control"
                id="recipient-name"
                name='name'
                onChange={editServiceProvider.handleChange}
                value={editServiceProvider.values.name}
              />
              {editServiceProvider.touched.name && editServiceProvider.errors.name ? (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {editServiceProvider.errors.name}
                </div>
              ) : null}
            </div>

            <div className='col-md-6'>
              <label htmlFor="recipient-name" className="col-form-label">Email*</label>
              <input type="text" className="form-control" id="recipient-name"
                name='email'
                // disabled
                value={editServiceProvider.values.email}
                onChange={editServiceProvider.handleChange}
              />
              {editServiceProvider.touched.email && editServiceProvider.errors.email ? (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {editServiceProvider.errors.email}
                </div>
              ) : null}
            </div>
            <div className='col-md-6'>
              <label htmlFor="recipient-name" className="col-form-label">Mobile Number*</label>
              <NumberInput
                width={false}
                Require={false}
                Name="mobileNo"
                HandleChange={editServiceProvider}
                Value={editServiceProvider.values.mobileNo}
                // disabledInput={true}
              />
              {editServiceProvider.touched.mobileNo && editServiceProvider.errors.mobileNo ? (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {editServiceProvider.errors.mobileNo}
                </div>
              ) : null}
            </div>
            <hr />
            <h5>Business Details</h5>
            <div className="col-md-6">
              <label htmlFor="recipient-name" className="col-form-label">Business Name*</label>
              <input type="text" className="form-control"
                id="recipient-name"
                name='businessName'
                onChange={editServiceProvider.handleChange}
                value={editServiceProvider.values.businessName}
                min={3}
              />
              {editServiceProvider.touched.businessName && editServiceProvider.errors.businessName ? (
                <div style={{ color: "red", fontSize: "13px" }}>
                  {editServiceProvider.errors.businessName}
                </div>
              ) : null}
            </div>
            <div className="col-md-6">
              <label htmlFor="recipient-name" className="col-form-label">Business Category*</label>
              <input type="text" className="form-control"
                id="recipient-name"
                name='category'
                onChange={editServiceProvider.handleChange}
                value={editServiceProvider.values.category}
              />
              {editServiceProvider.touched.category && editServiceProvider.errors.category ? (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {editServiceProvider.errors.category}
                </div>
              ) : null}
            </div>
            <div className='col-md-6'>
              <label htmlFor="recipient-name" className="col-form-label">About*</label>
              <textarea className="form-control" name='about' value={editServiceProvider.values.about} onChange={editServiceProvider.handleChange} cols="30" rows="3" ></textarea>
              {editServiceProvider.touched.about && editServiceProvider.errors.about ? (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {editServiceProvider.errors.about}
                </div>
              ) : null}
            </div>
            <div className='d-flex justify-content-end mb-5'>
              <button type="submit" className="btn btn-primary col-0">Update</button>
            </div>
          </form>
        </div>
      </section>
    </>
  )
}

export default EditServiceProvider;